import React, { useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Divider from "@material-ui/core/Divider";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import MenuItem from "@material-ui/core/MenuItem";
import ProfilePlaceholder from "../../assets/images/ProfilePlaceholder.png";
import Menu from "@material-ui/core/Menu";
import HomeIcon from "@material-ui/icons/Home";
import MenuIcon from "@material-ui/icons/Menu";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import CkLogo from "../../assets/images/ck_logo_new.png";
import DrawerBar from "./DrawerBar/DrawerBar";

const useStyles = makeStyles((theme) => ({
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: "100%",
    },
    zIndex: theme.zIndex.drawer + 1,
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
    marginTop: 10,
    fontSize: 20,
    fontStyle: "italic",
    fontWeight: 600,
    marginLeft: 10,
    whiteSpace: "pre-wrap",
    lineHeight: "normal",
    fontFamily: "Gill Sans MT",
  },
}));

const NavBar = (props) => {
  let { logo, isAuthorize, userName, title, hideTitle } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const open = Boolean(anchorEl);
  const classes = useStyles();

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const onLogout = () => {
    window.location.replace("#/logout");
  };
  const homepage = () => {
    window.location.replace("#/dashboard");
  };

  const handleDrawerToggle = () => {
    const value = !isDrawerOpen;
    setDrawerOpen(value);
  };

  const ckObject = localStorage.getItem("ckAdminUser") || "{}";
  const jsonCkObject = JSON.parse(ckObject) || {};
  const featureList = jsonCkObject.featureList || [];
  userName = userName || jsonCkObject.displayName || "N/A";

  return (
    <div id="headerCk">
      <AppBar color="primary" position="fixed" className={classes.appBar}>
        <Toolbar
          style={{
            paddingLeft: 3,
            display: "flex",
            justifyContent: "space-between",
            minHeight: `${isAuthorize ? "" : "57px"}`,
          }}
          variant="dense"
        >
          <div style={{ display: "flex" }}>
            {isAuthorize && (
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                style={{ marginLeft: 5 }}
                title={isDrawerOpen ? "Hide Menu" : "Show Menu"}
                onClick={() => handleDrawerToggle()}
              >
                {isDrawerOpen ? <ArrowBackIosIcon /> : <MenuIcon />}
              </IconButton>
            )}

            <IconButton
              style={{ padding: 5 }}
              color="inherit"
              aria-label="Menu"
            >
              <img alt="" src={logo ? logo : CkLogo} width={30} />
            </IconButton>
            <Typography className={classes.title} variant="subtitle1" noWrap>
              {hideTitle ? "" : title}
            </Typography>
          </div>
          {isAuthorize && (
            <div>
              <IconButton
                style={{ color: "white" }}
                onClick={homepage}
                title="Go to home page"
              >
                <HomeIcon />
              </IconButton>

              <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="inherit"
              >
                <img
                  alt=""
                  style={{ borderRadius: "50%" }}
                  src={ProfilePlaceholder}
                  width={30}
                />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={open}
                onClose={handleClose}
              >
                <MenuItem
                  style={{
                    fontWeight: "bold",
                    fontSize: 14,
                    textTransform: "capitalize",
                  }}
                  onClick={handleClose}
                >
                  {userName}
                </MenuItem>
                <Divider />
                <MenuItem onClick={() => onLogout()} style={{ fontSize: 12 }}>
                  Logout
                </MenuItem>
              </Menu>
            </div>
          )}
        </Toolbar>
      </AppBar>
      <DrawerBar
        featureList={featureList}
        isDrawerOpen={isDrawerOpen}
        toggleDrawerOpen={() => handleDrawerToggle()}
      />
    </div>
  );
};
NavBar.propTypes = {
  logo: PropTypes.any,
  title: PropTypes.string,
  userName: PropTypes.string,
  isAuthorize: PropTypes.bool,
  hideTitle: PropTypes.bool,
  isOpenMenu: PropTypes.bool,
  setOpenMenu: PropTypes.func,
};

NavBar.defaultProps = {
  logo: null,
  title: "Color Kahar",
  userName: "",
  isAuthorize: false,
  hideTitle: false,
  isOpenMenu: false,
  setOpenMenu: (fn) => fn,
};

export default NavBar;
